module.exports = __webpack_public_path__ + "svgs/arrow-right.71325a66.svg";